/* eslint-disable */
/*
  Facebook
*/
export function initFacebook(postmate, facebookAppId) {
  return new Promise((resolve, reject) => {
    if (window.FB) {
      resolve()
    }
    window.fbAsyncInit = function () {
      FB.init({
        appId: facebookAppId,
        autoLogAppEvents: false,
        xfbml: false,
        version: 'v2.11'
      })
      checkFacebookStatus(postmate)
      resolve()
    }
    var js, fjs = document.getElementsByTagName('script')[0]
    if (document.getElementById('facebook-jssdk')) { return }
    js = document.createElement('script'); js.id = 'facebook-jssdk'
    js.src = 'https://connect.facebook.net/en_US/sdk.js'
    fjs.parentNode.insertBefore(js, fjs)
  })
}

export function checkFacebookStatus (postmate) {
  if (FB) {
    FB.getLoginStatus(function (response) {
      const facebookData = {}
      facebookData['facebook'] = {
        isLoggedIn: response.status !== 'unknown'
      }

      postmate.call('socialMediaDataUpdate', facebookData)
    });
  }
}

export function connectFacebook (postmate) {
  if (FB) {
    FB.login(function (response) {
      if (response.status === 'connected') {
        getFacebookInfo(postmate, response.authResponse && response.authResponse.accessToken)
      }
    }, {scope: 'public_profile,email'})
  }
}

export function getFacebookInfo (postmate, accessToken) {
  FB.api('/me?fields=email,first_name,last_name,age_range', function (response) {

    response['firstName'] = response.first_name
    delete response.first_name
    response['lastName'] = response.last_name
    delete response.last_name

    const facebookData = {
      socialSignIn: true,
      provider: 'Facebook',
      accessToken,
      facebook: {
        profile: response
      }
    }
    postmate.call('socialMediaDataUpdate', facebookData)
  });
}

/*
  Google
*/
export function initGoogle(postmate, googleId) {
  const googleOnloadInit = window.googleOnloadInit = function () {
    gapi.load('auth2', async function () {
      window.GoogleAuth = await gapi.auth2.init({
        client_id: googleId
      })
    });
  };

  const googleScriptId = 'google-platform-js'
  const googleScriptExists = document.getElementById(googleScriptId)
  const firstScript = document.getElementsByTagName('script')[0]

  if (!googleScriptExists) {
    const googleScript = document.createElement('script');
    googleScript.id = googleScriptId
    googleScript.src = 'https://apis.google.com/js/platform.js?onload=googleOnloadInit'
    return firstScript.parentNode.insertBefore(googleScript, firstScript)
  }

  googleOnloadInit()
}

export function connectGoogle(postmate) {
  const isSignedIn = GoogleAuth.isSignedIn.get()
  if (GoogleAuth && !isSignedIn) {
    GoogleAuth.signIn().then((GoogleUser) => {
      getGoogleInfo(postmate)
    })
  } else if(GoogleAuth) {
    getGoogleInfo(postmate)
  }
}

export function getGoogleInfo(postmate) {
  const googleUser = GoogleAuth.currentUser.get()
  const profile = googleUser.getBasicProfile()
  const authData = googleUser.getAuthResponse(true)

  const googleData = {
    socialSignIn: true,
    provider: 'Google',
    accessToken: authData.access_token,
    google: {
      profile: {
        firstName: profile.getGivenName(),
        lastName: profile.getFamilyName(),
        email: profile.getEmail()
      }
    }
  }
  postmate.call('socialMediaDataUpdate', googleData)
}

/*
  LinkedIn
*/
export function initLinkedIn(postmate, linkedInId) {
  const scriptId = 'linked-in-sdk'
  const linkedInScriptExists = document.getElementById(scriptId)
  const firstScript = document.getElementsByTagName('script')[0]
  if (!linkedInScriptExists) {
    const linkedInScript = document.createElement('script');
    linkedInScript.id = scriptId
    linkedInScript.src = '//platform.linkedin.com/in.js'
    linkedInScript.async = true
    linkedInScript.innerHTML = `
      api_key: ${linkedInId}
      authorize: false
      scope: r_basicprofile r_emailaddress
    `
    return firstScript.parentNode.insertBefore(linkedInScript, firstScript)
  }
}

export function connectLinkedIn(postmate) {
  if (IN) {
    IN.User.authorize(() => {
      IN.API.Profile('me')
        .fields(['id', 'firstName', 'lastName', 'email-address'])
        .result((me) => {
          const profileData = me.values[0]
          const linkedInData = {
            socialSignIn: true,
            provider: 'LinkedIn',
            accessToken: IN.ENV.auth.oauth_token,
            linkedIn: {
              profile: {
                firstName: profileData.firstName,
                lastName: profileData.lastName,
                email: profileData.emailAddress
              }
            }
          }
          postmate.call('socialMediaDataUpdate', linkedInData)
        })
    })
  }
}


export default {
  initFacebook,
  connectFacebook,
  initGoogle,
  connectGoogle,
  initLinkedIn,
  connectLinkedIn
}



// WEBPACK FOOTER //
// ./src/utils/socialMedia.js